import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useSession, type Role } from '@/app/store/session.store';

import { homeFor, PLATFORM_HOME, TENANT_HOME } from './homes';

type Props = { roles?: Role[] };

/**
 * Protects a route group. Anonymous users go to /login (remembering where they were).
 * Platform admins only ever see /platform/*; tenant users never see it.
 */
export function RequireAuth({ roles }: Props) {
  const { status, user } = useSession();
  const location = useLocation();

  if (status !== 'authenticated' || !user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  const inPlatform = location.pathname.startsWith('/platform');
  if (user.role === 'PLATFORM_ADMIN' && !inPlatform) return <Navigate to={PLATFORM_HOME} replace />;
  if (user.role !== 'PLATFORM_ADMIN' && inPlatform) return <Navigate to={TENANT_HOME} replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={homeFor(user.role)} replace />;
  return <Outlet />;
}

/** Root route: forwards to the home screen of the current role. */
export function RoleHome() {
  const { status, user } = useSession();
  if (status !== 'authenticated' || !user) return <Navigate to="/login" replace />;
  return <Navigate to={homeFor(user.role)} replace />;
}
